import React from 'react';

export const McgJazzLogo = ({ size = 32, color = 'currentColor', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 120"
    width={size}
    height={size * 1.2}
    className={className}
    aria-label="MCG Jazz"
    role="img"
  >
    {/* Trumpet player silhouette */}
    <g fill={color}>
      {/* Head */}
      <circle cx="58" cy="12" r="7" />
      {/* Trumpet bell */}
      <path d="M68 8 L82 2 L84 6 L70 12Z" />
      <path d="M82 0 Q90 4 82 8Z" />
      {/* Torso */}
      <path d="M52 18 Q48 28 46 42 Q44 50 48 56 L58 56 Q62 50 60 42 Q58 28 56 18Z" />
      {/* Arms */}
      <path d="M56 22 Q62 26 66 24 Q70 22 68 14" strokeWidth="4" stroke={color} fill="none" strokeLinecap="round" />
      {/* Left arm */}
      <path d="M52 24 Q46 30 42 28 Q38 26 40 34" strokeWidth="3.5" stroke={color} fill="none" strokeLinecap="round" />
      {/* Legs */}
      <path d="M48 56 Q42 72 38 88 Q36 94 40 96 L44 96 Q46 94 48 86 Q50 72 52 60Z" />
      <path d="M54 56 Q56 72 54 88 Q52 94 56 96 L60 96 Q62 94 58 86 Q56 72 56 60Z" />
      {/* Feet */}
      <path d="M38 94 Q36 98 34 100 L46 100 L46 96Z" />
      <path d="M54 94 Q52 98 50 100 L62 100 L62 96Z" />
    </g>
    {/* Oval ring / stage */}
    <ellipse cx="50" cy="98" rx="42" ry="10" fill="none" stroke={color} strokeWidth="3" opacity="0.35" />
  </svg>
);
